import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import { createPortal } from 'react-dom';
import { useStyles, useToken, StyleSheet } from '@rexlabs/styling';
import { TransitionList } from '@rexlabs/animation';
import { Overlay } from '@rexlabs/overlay';
import { PrimaryIconButton } from '@rexlabs/button';
import { Menu } from '../menu';
import { DefaultCloseButton } from '../menu/close-button';
import { ActionMenuContent } from '../content';
import { useOutsideClick } from '../hooks/use-outside-click';
var defaultStyles = StyleSheet({
  overlay: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center'
  }
});
export function OverlayActionMenu(_ref) {
  var items = _ref.items,
      subItems = _ref.subItems,
      title = _ref.title,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      _ref$portalTarget = _ref.portalTarget,
      portalTarget = _ref$portalTarget === void 0 ? window.document.body : _ref$portalTarget,
      handleClose = _ref.handleClose,
      Icon = _ref.Icon,
      _ref$Button = _ref.Button,
      Button = _ref$Button === void 0 ? PrimaryIconButton : _ref$Button,
      TitleIcon = _ref.TitleIcon,
      _ref$CloseButton = _ref.CloseButton,
      CloseButton = _ref$CloseButton === void 0 ? DefaultCloseButton : _ref$CloseButton,
      isOpen = _ref.isOpen,
      selectedItem = _ref.selectedItem,
      highlightedIndex = _ref.highlightedIndex,
      selectItem = _ref.selectItem,
      getItemProps = _ref.getItemProps,
      getMenuProps = _ref.getMenuProps,
      getToggleButtonProps = _ref.getToggleButtonProps,
      onKeyDown = _ref.onKeyDown;
  var s = useStyles(defaultStyles);
  var token = useToken();

  var _useOutsideClick = useOutsideClick({
    enabled: isOpen,
    onOutsideClick: handleClose
  }),
      buttonRef = _useOutsideClick.buttonRef,
      menuRef = _useOutsideClick.menuRef;

  var menuProps = getMenuProps({
    ref: menuRef
  }, {
    suppressRefError: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({}, getToggleButtonProps({
    ref: buttonRef
  }), {
    role: "menubutton",
    tabIndex: 0,
    onKeyDown: onKeyDown,
    Icon: Icon
  })), /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(Overlay, _extends({}, s('overlay'), {
    show: isOpen
  }), /*#__PURE__*/React.createElement(TransitionList, {
    configs: ['slideUp', {
      trail: token('duration.slow'),
      duration: token('duration.slow'),
      easing: token('easing.smooth')
    }]
  }, isOpen && (subItems ? /*#__PURE__*/React.createElement(Menu, _extends({}, menuProps, {
    key: "mainItems",
    title: title,
    minWidth: minWidth,
    maxWidth: maxWidth,
    selectedItem: selectedItem,
    handleClose: handleClose,
    selectItem: selectItem,
    TitleIcon: TitleIcon,
    CloseButton: CloseButton
  }), /*#__PURE__*/React.createElement(ActionMenuContent, {
    items: subItems,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps
  })) : /*#__PURE__*/React.createElement(Menu, _extends({}, menuProps, {
    key: "subItems",
    title: title,
    minWidth: minWidth,
    maxWidth: maxWidth,
    selectedItem: selectedItem,
    handleClose: handleClose,
    selectItem: selectItem,
    TitleIcon: TitleIcon,
    CloseButton: CloseButton
  }), /*#__PURE__*/React.createElement(ActionMenuContent, {
    items: items,
    highlightedIndex: highlightedIndex,
    getItemProps: getItemProps
  }))))), portalTarget));
}